import baseURL from "../common/axios";
import { API_MSHospitalBaseUrl } from "../common/common";

class Supplierservices {
  // insert api call from supplier form
  insert(data_insert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("SupplierMAS/Create", data_insert);
  }

  // get edit data from table to form
  EditData(EditID) {
    return baseURL.httpMSInventoryUrl.get("SupplierMAS/Get?id=" + EditID + "");
  }

  // update data from form
  update(data_insert) {
    return baseURL.httpMSInventoryUrl.post("SupplierMAS/Update", data_insert);
  }

  // delete api for deleting data from table
  deletedata(doc) {
    return baseURL.httpMSInventoryUrl.delete("SupplierMAS/Delete?id=" + doc);
  }

  // Active api for activating data from table

  active(Id, Status) {
    return baseURL.httpMSInventoryUrl.put(
      "SupplierMAS/Active?id=" + Id + "&Status=" + Status + ""
    );
  }

  // dropdown api for supplier category
  getdata() {
    return baseURL.httpMSInventoryUrl.get("SupplierCategoryMAS/List");
  }

  // get data for supplier master table
  gettable() {
    return baseURL.httpMSInventoryUrl.get("SupplierMAS/List");
  }

  // dropdown api for payment terms
  getpaymentstermsdd() {
    return baseURL.httpMSInventoryUrl.get("PaymentTermsMAS/List");
  }

  GetSuppliersByStoreId(StoreId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "SupplierMAS/GetSuppliersByStoreId?StoreId=" + StoreId + "&BranchId=" + BranchId + ""
    );
  }

  //FileInsert
  Fileinsert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "SupplierImagesMAS/Create",
      objinsert
    );
  }
  DeleteList(Id) {
    return baseURL.httpMSInventoryUrl.delete("SupplierImagesMAS/DeleteList?id=" + Id)
  }
  //Get Files by Manufacture Id
  GetFilesBySupplierId(SupplierId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "SupplierImagesMAS/ListSupplierImagesMASBySupplierMASId?SupplierId=" +
      SupplierId +
      ""
    );
  }

  CreateSupplierStore(List) {
    return baseURL.httpMSInventoryUrl.post("SupplierStoreBranchMapping/Create", List)
  }

  getSupplierStoreBySupplierId(SupplierId) {
    return baseURL.httpMSInventoryUrl.get("SupplierStoreBranchMapping/Get?SupplierId=" + SupplierId)
  }

  deleteSupplierStore(IdsList) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("SupplierStoreBranchMapping/Delete", IdsList)
  }

  getSupplierStoreByStoreId(StoreId, BranchId) {
    return baseURL.httpMSInventoryUrl.get("SupplierStoreBranchMapping/GetSupplierByStoreId?StoreId=" + StoreId + "&BranchId=" + BranchId)
  }

}
export default new Supplierservices();
